import { Box, Heading, Body, BoxProps } from '@hover/blueprint';
import React from 'react';
import QuotationMarkIconNavy from '../../../assets/svgs/QuotationMarkIconNavy';

interface Props extends BoxProps {
  body: string;
  name: string;
  role: string;
}

const CustomerQuoteInfo: React.FC<Props> = ({ body, name, role, ...rest }) => (
  <Box flexDir="column" alignItems="flex-start" {...rest}>
    <Box flexDir="row" alignItems="flex-start">
      <QuotationMarkIconNavy
        width={50}
        style={{ paddingBottom: '5px', minWidth: 50 }}
      />
      <Heading
        ml={200}
        size={{ base: 200, desktop: 500 }}
        fontWeight={{ base: 400, desktop: 400 }}
        style={{ marginBottom: '24px' }}
      >
        {body}
      </Heading>
    </Box>
    <Box pl="58px" flexDir="column" alignItems="flex-start">
      <Body size={300} isBold marginBottom={0} letterSpacing="1px">
        {name.toUpperCase()}
      </Body>
      <Body letterSpacing="1px" size={300} mb={600}>
        {role.toUpperCase()}
      </Body>
    </Box>
  </Box>
);

export default CustomerQuoteInfo;
